export const SORT_EDITOR_LOCALE_ZHCHT = {
    // åæ¶
    cancel: 'åæ¶',
    // ç¢ºå®
    ok: 'ç¢ºå®',
    // æ·»å å­å¥
    add: 'æ·»å ',
    clear: 'æ¸ç©º',
    // ç½®é 
    moveTop: 'ç½®é ',
    // ä¸ç§»
    moveUp: 'ä¸ç§»',
    // ä¸ç§»
    moveDown: 'ä¸ç§»',
    // ç½®åº
    moveBottom: ' ç½®åº',

    // å­æ®µ
    field: 'å­æ®µ',
    // æåº
    order: 'æåº',
    asc: 'ååº',
    desc: 'éåº',
    title: 'æåºè¨­ç½®',
    clearAll: 'ç¢ºèªè¦æ¸ç©ºæææåºå­æ®µåï¼'
};
